class VwOrgYetkiKullaniciDTO {
    id?: number;
    fkOrganizasyon?: number;
    kullaniciId?: number;
    eklemeTarihi?: string;
    ekleyenKullanici?: number;
    organizasyon?: string;
    kullaniciAdsoyad?: string;
    kodu?: string;
}
export default VwOrgYetkiKullaniciDTO;